// extracted by mini-css-extract-plugin
export var modal = "_el-0";